import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import xinThoiViecService from "services/hrm/xinThoiViecService";

export const create = createAsyncThunk(
  "xinThoiViecSlice/create",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess}= data
      const response = await xinThoiViecService.create(data);
      if(onSuccess)onSuccess(response.data)
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const update = createAsyncThunk(
  "xinThoiViecSlice/update",
  async (data, { rejectWithValue }) => {
    try {
        const {onSuccess}= data
      const response = await xinThoiViecService.update(data);
      if(onSuccess)onSuccess(response.data)
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const deletebyid = createAsyncThunk(
  "xinThoiViecSlice/deletebyid",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess,id}= data
      const response = await xinThoiViecService.delete(id);
      if(onSuccess)onSuccess(response.data)
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getbyid = createAsyncThunk(
  "xinThoiViecSlice/getbyid",
  async (data, { rejectWithValue }) => {
    try {
      const {onSuccess,id}= data
      const response = await xinThoiViecService.getbyid(id);
      if(onSuccess)onSuccess(response.data.data)
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const getall = createAsyncThunk(
  "xinThoiViecSlice/getall",
  async (data, { rejectWithValue }) => {
    try {
      const response = await xinThoiViecService.search(data);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);




const initialState = {
  loading: false,
  danhSachXinThoiViec: [],
  xinThoiViecDetail:{},

};

const xinThoiViecSlice = createSlice({
  name: "xinThoiViecSlice",
  initialState,
  reducers: {
    resetxinThoiViecDetail: (state) => {
      state.xinThoiViecDetail = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(create.pending, (state) => {
        state.loading = true;
      })
      .addCase(create.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(create.rejected, (state) => {
        state.loading = false;
      })

      .addCase(update.pending, (state) => {
        state.loading = true;
      })
      .addCase(update.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(update.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deletebyid.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletebyid.fulfilled, (state, action) => {
        state.loading = false;
        
      })
      .addCase(deletebyid.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getbyid.pending, (state) => {
        state.loading = true;
      })
      .addCase(getbyid.fulfilled, (state, action) => {
        state.loading = false;
        state.xinThoiViecDetail = action.payload;
      })
      .addCase(getbyid.rejected, (state) => {
        state.loading = false;
       
      })
      
      .addCase(getall.pending, (state) => {
        state.loading = true;
      })
      .addCase(getall.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachXinThoiViec= action.payload

      })
      .addCase(getall.rejected, (state) => {
        state.loading = false;
      })

      ;
  },
});
// eslint-disable-next-line no-empty-pattern
export const {resetxinThoiViecDetail} = xinThoiViecSlice.actions;

export default xinThoiViecSlice.reducer;
